export default __webpack_public_path__ + "static/media/sidepolygon.07bd46cc.svg";